module.exports = __webpack_public_path__ + "e8f1e1b6306f2b8067d812f310a771eb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-24.png
// module id = 1502
// module chunks = 0